import PosthogService from '~/services/posthog/PosthogService';

export interface IShiftRequestLastMinuteAutoconfirmExperimentExposedPayload {
  flagKey: string;
  variant: string;
}

/**
 * Fires once per shift request, only for postings that actually qualify for the last-minute
 * Auto-Confirm treatment (EVERY shift in the posting starting within 48h). Used as the
 * experiment's custom exposure event: the automatic `$feature_flag_called` fires on every render
 * of the Auto-Confirm section, so it would count offices posting weeks out — who could never be
 * treated — as exposed and dilute the result.
 *
 * Its own event name, so the experiment never depends on a `$feature_flag` property filter to
 * separate it from other auto-confirm events.
 * Event: dental_portal:shift_request:last_minute_autoconfirm_experiment_exposed
 */
export function fireShiftRequestLastMinuteAutoconfirmExperimentExposed(
  payload: IShiftRequestLastMinuteAutoconfirmExperimentExposedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:shift_request:last_minute_autoconfirm_experiment_exposed',
    {
      $feature_flag: payload.flagKey,
      $feature_flag_response: payload.variant,
    },
  );
}
